import React, { PropsWithChildren } from "react";

export function GridGrow(props: PropsWithChildren<{}>){
    return (<div style={{ flex: "1 1 auto" }} >{props.children}</div>);
}